import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Heading(_: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.heading}>
      <p>{t("zonesPage.zones.heading.zone")}</p>
      <p>{t("zonesPage.zones.heading.projectNbr")}</p>
      <p>{t("zonesPage.zones.heading.weather")}</p>
      <p />
    </div>
  );
}

export { Heading };
